import { createGlobalStyle } from 'styled-components';

export const colorBlue1 = '#027AAE';
export const colorBlue2 = 'rgba(2,122,174,0.03)';
export const colorRed1 = '#D91919';
export const colorRed2 = 'rgba(255,0,0,0.02)';
export const colorGreen1 = 'rgba(83,174,2,0.1)';
export const colorGreen2 = '#53AE02';
export const colorYellow1 = '#E9AB00';
export const colorYellow2 = '#FFF6DC';

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
  }

  html, border-style, #root {
    min-height: 100%;
  }

  #root {
    position: relative;
    height: calc(100vh - 80px);
    overflow-y: auto;
    overflow-x: hidden;
    z-index: 1;
  }

  body{
    background: #f1f1f3!important;
    -webkit-font-smoothing: antialiased !important;
    font-family: HPSimplified, Arial, sans-serif;
  }

  body, input, button {
    font-size: 14px;
  }

  button {
    cursor: pointer;
  }

  #printosHeader {
    position: relative;
    display: block;
    width: 100%;
    overflow: hidden;
  }

  .smallerText {
    display: block;
    color: #555;
    font-size: 80% !important;
    line-height: 1;
  }

  img {
    position: relative;
  }

  img[alt]:after {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #fff;
    font-family: 'Helvetica';
    font-weight: 300;
    line-height: 2;
    text-align: center;
    content: attr(alt);
  }

  /* helper classes for spaces */
  .padding-xsmall {padding: 5px !important;}
  .padding-small {padding: 10px !important;}
  .padding-medium {padding: 15px !important;}
  .padding-large {padding: 20px !important;}
  .padding-xlarge {padding: 25px !important;}

  .padding-x-xsmall {padding: 0 5px !important;}
  .padding-x-small {padding: 0 10px !important;}
  .padding-x-medium {padding: 0 15px !important;}
  .padding-x-large {padding: 0 20px !important;}
  .padding-x-xlarge {padding: 0 25px !important;}

  .padding-y-xsmall {padding: 5px 0 !important;}
  .padding-y-small {padding: 10px 0 !important;}
  .padding-y-medium {padding: 15px 0 !important;}
  .padding-y-large {padding: 20px 0 !important;}
  .padding-y-xlarge {padding: 25px 0 !important;}

  .margin-xsmall {margin: 5px !important;}
  .margin-small {margin: 10px !important;}
  .margin-medium {margin: 15px !important;}
  .margin-large {margin: 20px !important;}
  .margin-xlarge {margin: 25px !important;}

  .margin-x-xsmall {margin: 0 5px !important;}
  .margin-x-small {margin: 0 10px !important;}
  .margin-x-medium {margin: 0 15px !important;}
  .margin-x-large {margin: 0 20px !important;}
  .margin-x-xlarge {margin: 0 25px !important;}

  .margin-y-xsmall {margin: 5px 0 !important;}
  .margin-y-small {margin: 10px 0 !important;}
  .margin-y-medium {margin: 15px 0 !important;}
  .margin-y-large {margin: 20px 0 !important;}
  .margin-y-xlarge {margin: 25px 0 !important;}

  .d-flex {
    display: flex;
  }

  .align-right {
    display: flex;
    justify-content: right;
  }

  .align-text-right {
    text-align: right;
  }
  .align-text-left {
    text-align: left;
  }
  .align-text-center {
    text-align: center;
  }

  .customizedTabs {
    @media all and (min-width: 1200px) {
      z-index: 10000;
    }
    .vn-tab-list__tab {
      padding: 0px!important;
      border-width: 2px!important;
    }
    .vn-tab-list__label {
      overflow: visible!important;
    }
    .tooltip--children {
      padding: 12px 16px;
    }
  }

  .line-break {
    border: none;
    border-top: solid 1px rgba(0,0,0,0.1);
    margin: 10px 0;
  }

  .text-small {
    font-size: 90%;
  }

  .devices-Wrapper {
    align-items: flex-start;
    flex-flow: row wrap;
  }
`;
